import React, { useState } from "react";
import api, { formatErr } from "@/lib/api";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { Field } from "./Login";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [token, setToken] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setToken(data.reset_token || "");
      setSent(true);
      toast.success("Reset link generated");
    } catch (e) { toast.error(formatErr(e?.response?.data?.detail)); }
  };
  return (
    <main className="max-w-md mx-auto p-8">
      <h1 className="font-display text-3xl font-bold">Forgot Password</h1>
      {!sent ? (
        <form onSubmit={submit} className="mt-6 space-y-4">
          <Field label="Email" type="email" value={email} onChange={setEmail} testid="forgot-email"/>
          <button data-testid="forgot-submit" className="btn-primary-sf w-full py-3 rounded-full font-semibold">Send reset link</button>
        </form>
      ) : (
        <div className="mt-6 text-sm text-slate-700 bg-slate-50 rounded-2xl p-4">
          <p className="mb-3">A reset token has been generated. Use it on the reset page.</p>
          {token && <code className="block bg-white border border-slate-200 rounded-xl p-3 break-all">{token}</code>}
          <Link to={`/reset-password?token=${token}`} data-testid="goto-reset" className="btn-primary-sf inline-flex mt-4 px-5 py-2 rounded-full text-sm font-semibold">Reset now</Link>
        </div>
      )}
    </main>
  );
}
